import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-openeye",
  "use": "icon-openeye-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-openeye\"><path d=\"M512 204.8c-278.016 0-460.8 279.04-460.8 279.04S186.368 819.2 512 819.2s460.8-335.36 460.8-335.36S790.016 204.8 512 204.8m0 502.272A200.19 200.19 0 0 1 307.2 512 200.19 200.19 0 0 1 512 316.928 200.19 200.19 0 0 1 716.8 512 200.19 200.19 0 0 1 512 707.072m0-297.472A102.4 102.4 0 1 0 614.4 512 102.4 102.4 0 0 0 512 409.6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol